import React from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {InteractiveTable} from 'components';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {NmbrTaxDocument} from 'main/stores/nmbr';

const ViewFileButton = observer(({model}) => {
  return (
    <a
      className='TextLink dodger'
      href={`/api/v1${endpoints.NMBR.TAX_DOCUMENT.with(model.id)}`}
      target='_blank'
    >
      <FormattedMessage id='employees.profile.banking.View File'/>
    </a>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.banking.Document Type',
    width: 4,
    attribute: 'name'
  },
  {
    header: 'employees.profile.banking.Tax Year',
    width: 6,
    attribute: 'taxYear'
  },
  {
    width: 2,
    className: 'right-align',
    component: ViewFileButton
  }
];

const NmbrTaxDocumentsTable = observer(({employee}) => {
  return (
    <InteractiveTable
      title={t('employees.profile.banking.Tax Documents')}
      columns={COLUMNS}
      showLinks={false}
      searchable={false}
      sortable={false}
      proxy={{
        type: 'async',
        modelType: types.NMBR.TAX_DOCUMENT,
        model: NmbrTaxDocument,
        endpoint: endpoints.NMBR.TAX_DOCUMENTS.with(employee.id),
        pageSize: 15
      }}
    />
  );
});

export default NmbrTaxDocumentsTable;
